import httpUtil from "@/utils/httpUtil";

export const selectCompanyList = params => httpUtil.get("/branchCompany", params);
export const addOrUpdateBranchCompany = params => httpUtil.post("/branchCompany/add", params);
export const delBranchCompany = params => httpUtil.post("/branchCompany/delete",params);
export const selectAllCompanyList = params => httpUtil.get("/branchCompany/noPage", params);


